export const permissions = {
    permissionsAll: ['master', 'host', 'receptionist'],
    permissionHostAndMaster: ['master', 'host'],
    permissionRecepcionistAndMaster: ['receptionist', 'master'],
    permissionMaster: ['master'],
    recepcionist: ['receptionist'],
};
